import { render, staticRenderFns } from "./MSPointSetting.vue?vue&type=template&id=1cf4d0ce&"
import script from "./MSPointSetting.vue?vue&type=script&lang=js&"
export * from "./MSPointSetting.vue?vue&type=script&lang=js&"
import style0 from "./MSPointSetting.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports